<template lang="pug">
.estado-inicial
  slot
    .estado-inicial-padrao
      img.estado-inicial-padrao__icone(src="../../../static/icones/lupa.svg")
      p.estado-inicial-padrao__titulo {{ $t('compartilhados.SmartTable.EstadoInicial.mensagem') }}
      p.estado-inicial-padrao__descricao(v-if="descricao") {{ descricao }}
      .estado-inicial-padrao__acao(v-if="$slots.acao")
        slot(name="acao")
</template>

<script>
export default {
  name: 'EstadoInicial',
  props: {
    // Microcopy de orientação (próximo passo). Opcional — quando omitido, nada
    // é exibido. Ex.: "Use os filtros acima para encontrar os registros desejados."
    descricao: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.estado-inicial {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);

  &-padrao {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;

    &__icone {
      width: 56px;
      opacity: 0.7;
    }

    &__titulo {
      color: var(--texto-forte);
      margin: 0;
      font-size: 1rem;
      font-weight: 600;
    }

    &__descricao {
      color: var(--texto-suave);
      margin: 0;
      font-size: 0.875rem;
      text-align: center;
    }

    &__acao {
      margin-top: 0.25rem;
    }
  }
}
</style>
